/**
 * Plain words for stored values (design system › Content: people read
 * "Medium" and "In progress", never "MEDIUM" or "IN_PROGRESS").
 *
 * Sentence case: the first word capitalised, the rest lower case, except the
 * acronyms and standard names below, which keep their capitals. Use a local
 * label map instead where a value needs different words altogether.
 */
const KEEP = new Set([
  'AI', 'API', 'BCP', 'CIS', 'CSF', 'DPA', 'DR', 'DSS', 'GDPR', 'HIPAA', 'HK', 'ID', 'ISO', 'IT', 'KPI',
  'M365', 'MFA', 'NDA', 'NIST', 'OIDC', 'PCI', 'PDF', 'PII', 'SAML', 'SLA', 'SMTP', 'SOC', 'SOC2', 'SSO',
  'TLS', 'UK', 'US', 'VPN',
]);

/**
 * Values that already have a name elsewhere in the app (Users › roles,
 * Exercises › types). Kept identical so one value never reads two ways.
 */
const NAMED: Record<string, string> = {
  ADMIN: 'Administrator', RISK_MANAGER: 'Risk Manager', COMPLIANCE_OFFICER: 'Compliance Officer',
  AUDITOR: 'Auditor', VIEWER: 'Viewer', CLIENT_ADMIN: 'Client Admin', CLIENT_USER: 'Client User',
  DR: 'Disaster Recovery', DATA_BREACH: 'Data Breach', INSIDER_THREAT: 'Insider Threat',
  SUPPLY_CHAIN: 'Supply Chain', CLOUD_INCIDENT: 'Cloud Incident',
  NON_COMPLIANT: 'Non-compliant',
};

export function humanize(value: string | null | undefined): string {
  if (!value) return '';
  if (NAMED[value]) return NAMED[value];
  const words = value.trim().split(/[_\s]+/).filter(Boolean);
  return words
    .map((w, i) => {
      const upper = w.toUpperCase();
      if (KEEP.has(upper)) return upper;
      const lower = w.toLowerCase();
      return i === 0 ? lower.charAt(0).toUpperCase() + lower.slice(1) : lower;
    })
    .join(' ');
}
